module.exports = new __parcel__URL__("LandInEditorIllustrationLight.28460c36.svg").toString();